import React from 'react';
import PropTypes from 'prop-types';
import {BlocksControls, InlineBlocks} from 'react-tinacms-inline';
import {box, text} from '../../constants/fields/fields';
import {Image} from './Image';
import {ImageListStyled} from './ImageListStyled';
import {imagesTemplate} from '../../constants/templates/image';
import {useBlockProps} from '../../hooks/useBlockProps';


const IMAGE_BLOCKS = {
  image: Image,
};


function ImageListComponent({index, data}) {
  const {blockProps} = useBlockProps(data);
  return (
    <BlocksControls index={index} focusRing={{offset: 0}} insetControls>
      <ImageListStyled {...blockProps}>
        <InlineBlocks
          name="blocks"
          blocks={IMAGE_BLOCKS}
          direction={'horizontal'}
          className="dfl-image-list"
        />
      </ImageListStyled>
    </BlocksControls>
  );
}

const template = {
  label: 'Image List',
  defaultItem: imagesTemplate,
  fields: [
    text,
    box
  ]
};
export const Images = {
  Component: ImageListComponent,
  template
};

ImageListComponent.propTypes = {
  data: PropTypes.object,
  index: PropTypes.number
};
